// extracted by mini-css-extract-plugin
module.exports = {"timestamp":"styles-module__timestamp___+ZeDi"};